package one.healthium.domain.user.models

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import one.healthium.base.utils.toHeightString
import one.healthium.base.utils.toWeightAndUnitString
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days


fun UserProfileModel.bindPlaceholderValues(template: String, isMetric: Boolean) = template
    .replace("""\{[^}]+\}""".toRegex()) { matchResult ->
        val splitedPlaceholder = matchResult.value.trim('{', '}').split("||")

        val placeholderValue = splitedPlaceholder.firstOrNull()
        val defaultValue = splitedPlaceholder.lastOrNull()

        val replaceValue = when (placeholderValue?.lowercase()) {
            "name" -> name?.trim()
            "age" -> age?.toString()
            "weight" -> weight?.toWeightAndUnitString(isMetric)
            "target_weight" -> targetWeight?.toWeightAndUnitString(isMetric)
            "height" -> height?.toHeightString(isMetric)
            "bmi" -> bmi?.toString()
            "target_bmi" -> targetBmi?.toString()
            "down_years" -> age?.let { it / 10 * 10 }?.toString()
            "your_teens" -> yourTeens
            "gender" -> gender?.displayValue()
            "lose_percent" -> losePercent?.let { "$it%" }
            "prognose_lose_21" -> prognoseLose?.toWeightAndUnitString(isMetric)
            "min_recommended_weight" -> minRecommendedWeight?.toWeightAndUnitString(isMetric)
            "max_recommended_weight" -> maxRecommendedWeight?.toWeightAndUnitString(isMetric)
            "weight_to_lose" -> weightToLose?.toWeightAndUnitString(isMetric)
            "prognose_weight_21" -> prognoseWeightLoss(PersonalPlanPeriod.In21days)?.toWeightAndUnitString(isMetric)
            "prognose_weight_3month" -> prognoseWeightLoss(PersonalPlanPeriod.In3month)?.toWeightAndUnitString(isMetric)
            "prognose_weight_3month_short" -> prognoseWeightLoss(PersonalPlanPeriod.In3monthShort)?.toWeightAndUnitString(isMetric)
            "in_21days" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In21days))
            "in_3months" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In3month))
            "in_3months_short" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In3monthShort))
            else -> additionalInfo[placeholderValue]?.firstOrNull()?.altText
        }
        replaceValue.let { if (it.isNullOrEmpty()) defaultValue else it }.orEmpty()
    }

private fun inPrognoseDays(days: Int): String {
    val days21 = Clock.System.now().plus(days.days)
    val dateFormat = LocalDate.Format {
        monthName(MonthNames.ENGLISH_FULL)
        char(' ')
        dayOfMonth()
    }

    return dateFormat.format(days21.toLocalDateTime(TimeZone.currentSystemDefault()).date)
}
